// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EEvV","index":"styles_index__t0lvc"};